module.exports = {
	"fi": {
		"conversation": {
			"widget": {
				"title": "Keskustele kanssamme chatissa"
			}
		}
	}
};